import { closeTaskSocketConnect, openTaskSocketConnect } from 'app/actions/task';
import { closeWebsocketConnect, openWebsocketConnect } from 'app/actions/websocket';
import { Helmet, Loader } from 'app/components';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from './routes';
// Экран обязательной смены пароля (FuelTrucks-2465): пока у пользователя
// стоит флаг must_change_password, остальные разделы недоступны.
const CHANGE_PASSWORD_PATH = '/account/change-password';
const checklistRoles = [config.userRoles['OPERATOR_CHECKLIST'], config.userRoles['ADMIN_CHECKLIST'], config.userRoles['INSPECTOR_OPERATOR_CHECKLIST']];
export const Router = (props) => {
    const dispatch = useDispatch();
    const { isLoading } = props;
    // eslint-disable-next-line no-unused-vars
    const { session, secret } = useSelector((state) => state.session);
    const { status } = useSelector((state) => state.websocket);
    const taskSocketStatus = useSelector((state) => { var _a; return (_a = state.task) === null || _a === void 0 ? void 0 : _a.socketStatus; });
    const mustChangePassword = !!(session === null || session === void 0 ? void 0 : session.must_change_password);
    const homePath = checklistRoles.includes(session === null || session === void 0 ? void 0 : session.role_id) ? '/checklist' : '/map';
    // Установить веб-сокет соединение.
    useEffect(() => {
        if (session) {
            if (status !== 'OPENED') {
                dispatch(openWebsocketConnect());
            }
            if (taskSocketStatus !== 'OPENED') {
                dispatch(openTaskSocketConnect());
            }
        }
        return () => {
            if (session) {
                dispatch(closeWebsocketConnect());
                dispatch(closeTaskSocketConnect());
            }
        };
    }, [session]);
    // Показать прелоадер, пока проверяются данные сеанса пользователя.
    if (isLoading) {
        return React.createElement(Route, { render: () => React.createElement(Helmet, { component: Loader }) });
    }
    // Продолжите загрузку маршрутизатора и определите пути маршрутизации приложений.
    return (React.createElement(Switch, null, routes.map((route, key) => {
        var _a;
        return (React.createElement(Route, { key: key, path: route.path, exact: (_a = route.exact) !== null && _a !== void 0 ? _a : false, render: () => {
                switch (route.auth) {
                    case 'optional':
                        // Экран смены пароля живёт рядом со страницами входа:
                        // показываем его только залогиненному пользователю с флагом.
                        if (route.path === CHANGE_PASSWORD_PATH) {
                            return session ? (mustChangePassword ? (React.createElement(route.layout, null,
                                React.createElement(Helmet, Object.assign({ component: route.component }, route)))) : (React.createElement(Redirect, { to: { pathname: homePath } }))) : (React.createElement(Redirect, { to: { pathname: '/' } }));
                        }
                        return session ? (React.createElement(Redirect, { to: { pathname: mustChangePassword ? CHANGE_PASSWORD_PATH : homePath } })) : (React.createElement(route.layout, null,
                            React.createElement(Helmet, Object.assign({ component: route.component }, route))));
                    case 'required':
                        if (mustChangePassword) {
                            return React.createElement(Redirect, { to: { pathname: CHANGE_PASSWORD_PATH } });
                        }
                        return !!session && session.permissions.some((permission) => route.permissions.includes(permission)) ? (React.createElement(route.layout, null,
                            React.createElement(Helmet, Object.assign({ component: route.component }, route)))) : (React.createElement(Redirect, { to: { pathname: '/' } }));
                    default:
                        return React.createElement(Helmet, Object.assign({ component: route.component }, route));
                }
            } }));
    })));
};
export default Router;
